/**
 * Stored rows of an UNSET Facility Group register (no Shared/Separated mode yet). It decides empty
 * (the first accepted run sets the mode) vs. populated (only Manual Only can be saved; pulls are
 * refused). RegisterVM carries no row count, so the schema's `totalRows` is read — as ExcelUpload
 * does. Registers that don't need it (Facility registers, Facility Group registers with a mode)
 * resolve to null without a request.
 */
import { isGroupRegister } from '../../../modules/registerImportWizardModel.js';

/** True when the register's kind depends on its row count. */
export function needsRowCount(register) {
  return isGroupRegister(register) && !register.facilityAssignmentMode;
}

/**
 * @param {?object} register - RegisterVM
 * @param {{ getRegisterSchema: function(string): Promise<object> }} service - registerService
 * @returns {Promise<?number>} the row count, or null when unknown / not needed. Rejects on a failed
 *   read so the caller can log it; callers fail open (the server refuses a populated register).
 */
export async function loadUnsetRegisterRowCount(register, service) {
  if (!needsRowCount(register)) return null;
  const schema = await service.getRegisterSchema(register.id);
  const total = Number(schema && schema.totalRows);
  return Number.isFinite(total) ? total : null;
}
